export type CrmLinkingStatus = "linked" | "invited" | "notInvited";

export function getCrmLinkingStatus({
  linkedSystemOrganisationId,
  isInvited,
}: {
  linkedSystemOrganisationId?: string | null;
  isInvited: boolean;
}): CrmLinkingStatus {
  if (linkedSystemOrganisationId) return "linked";
  if (isInvited) return "invited";
  return "notInvited";
}
